<script setup lang="ts">
import type { TrackRecordPreviewRow } from '@/types/services/mandate/trackRecord.type.ts'

defineProps<{
  headers: string[]
  rows: TrackRecordPreviewRow[]
}>()
</script>

<template>
  <div class="preview-table-wrapper">
    <v-table density="compact" fixed-header>
      <thead>
        <tr>
          <th v-for="header in headers" :key="header" class="text-left">
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in rows" :key="i">
          <td v-for="header in headers" :key="header">
            {{ row[header] ?? '—' }}
          </td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<style scoped>
.preview-table-wrapper {
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 4px;
}
</style>
